import { Path } from 'components/app.component'
import React, { useEffect, useState } from 'react'
import { Container, Grid2, Typography, TextField, Checkbox, FormControlLabel, FormControl } from '@mui/material'
import PhoneInput from 'react-phone-input-2'
import { useNavigate } from 'react-router-dom'
import { updateContactInfo, UpdateContactInfoResponse } from 'services/rentals-thin.service'
import './contact-information.css'
import 'react-phone-input-2/lib/style.css'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ReactInputDateMask from 'helpers/date-input-mask';
import { GlobalState, Rental, setNavigation, store, updateContactInfo as updateContectInfoInStore, disableButton, enableButton, ContactInfo } from 'store/rentals-store'
import { useSelector } from 'react-redux';
import { transformStringDate } from 'helpers/date-utils'

export default function ContactInformation() {
    const navigation = useNavigate()
    const rental: Rental = useSelector((state: GlobalState) => state.rental);
    const path: string = useSelector((state: GlobalState) => state.navigation.currentPath);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false)

    const validationSchema = Yup.object().shape({
        firstName: Yup.string()
            .min(1)
            .max(150, 'Nombre muy largo')
            .matches(/^[a-zA-Z\s]+$/, "Nombre incorrecto")
            .required('Campo obligatorio'),
        lastName: Yup.string()
            .min(1)
            .max(150, 'Apellido muy largo')
            .matches(/^[a-zA-Z\s]+$/, "Apellido incorrecto")
            .required('Campo obligatorio'),
        email: Yup.string()
            .min(1)
            .email('Email incorrecto')
            .required('Campo obligatorio'),
        phone: Yup.string()
            .min(1)
            .min(15, 'Telefono incorrecto')
            .required('Campo obligatorio'),
        birthDate: Yup.string()
            .min(1)
            .required(),
        dlCheck: Yup
            .boolean()
            .required()
            .oneOf([true], 'Debe contar con una credencial vigente.')
    });

    const formik = useFormik({
        initialValues: { firstName: "", lastName: "", email: "", phone: "", birthDate: "", dlCheck: false},
        onSubmit,
        validationSchema
    })

    // This is triggered after executing handleSubmit. See documentation https://formik.org/docs/api/useFormik
    async function onSubmit (contactInfo: ContactInfo) {
        try {
            setIsFormSubmitted(true)
            const formattedContactInfo: ContactInfo = {
                ...contactInfo,
                birthDate: transformStringDate(contactInfo.birthDate, "DD-MM-YYYY", "MM-DD-YYYY")
            }
            const response: UpdateContactInfoResponse = await updateContactInfo(formattedContactInfo);
            store.dispatch(updateContectInfoInStore(response.data));
            navigation(Path.Delivery)
            return;
        } catch (error) {
            console.error('there was an error updating contact info')
            store.dispatch(setNavigation(Path.Contact))
            setIsFormSubmitted(false)
            return;
        }
    }

    useEffect(() => {
        if (formik.dirty) {
            formik.isValid ? store.dispatch(enableButton()) : store.dispatch(disableButton())
        } else {
            store.dispatch(disableButton())
            if (rental.contactInfo) {
                formik.setValues(rental.contactInfo)
            }
        }
    })

    useEffect(() => {
        if (path === Path.Delivery && !isFormSubmitted) {
            formik.handleSubmit();
        }
    }, [path, isFormSubmitted])

    return(
        <Container>
            <Typography
                fontSize={{
                lg: 35,
                md: 25,
                sm: 20,
                xs: 20
            }}> Información de contacto</Typography>
            <form id="contactInfoForm"  onSubmit={formik.handleSubmit}>
            <Grid2 container spacing={2}>
                <Grid2 size={{xs:12, md:12, xl:6}}>
                    <FormControl fullWidth>
                        <TextField
                            id="firstName"
                            name="firstName"
                            label="Nombre(s) *"
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.firstName}
                            error={!!formik.errors.firstName}
                            variant='standard'
                        />
                    </FormControl>
                </Grid2>
                <Grid2 size={{xs:12, md:12, xl:6}}>
                    <FormControl fullWidth>
                        <TextField
                            id="lastName"
                            name="lastName"
                            label="Apellido(s) *"
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.lastName}
                            error={!!formik.errors.lastName}
                            variant='standard'
                        />
                    </FormControl>
                </Grid2>
                <Grid2 size={{xs:12, md:12, xl:6}}>
                    <FormControl fullWidth>
                        <TextField
                            data-length="150"
                            id="email"
                            label="Correo electrónico *"
                            onChange={formik.handleChange}
                            value={formik.values.email}
                            error={!!formik.errors.email}
                            variant='standard'
                        />
                    </FormControl>
                </Grid2>
                <Grid2 size={{xs:12, sm:12, md:12, lg:6}}>
                    <FormControl fullWidth>
                            <label htmlFor='birthDate' id='birthDateLabel' data-testid='birthDateLabel'>Fecha de Nacimiento *</label>
                            <ReactInputDateMask id='birthDate' mask='dd/mm/yyyy' showMaskOnFocus value={formik.values.birthDate} onChange={(value: string)=>formik.setFieldValue("birthDate", value)} />
                    </FormControl>
                </Grid2>
                <Grid2 size={{xs:12, sm:12, md:12, lg:6}}>
                    <FormControl fullWidth>
                        <label htmlFor="phone">Teléfono *</label>
                        <PhoneInput
                            containerStyle={{ display: 'flex', flexDirection: 'row-reverse'}}
                            country={'mx'}
                            value={formik.values.phone.replace(/\s/g, "")}
                            onChange={(_,__,e) => formik.handleChange(e)}
                            preferredCountries={['mx', 'us']}
                            placeholder="Teléfono *"
                            inputProps={{ id: 'phone', name: 'phone' }}
                            inputClass={formik.errors.phone ? 'invalid' : ''}
                        />
                    </FormControl>
                </Grid2>
                <Grid2 size={{xs:12, md:12, xl:6}}>
                    <FormControl fullWidth>
                        <FormControlLabel
                            control={
                            <Checkbox
                                value={formik.values.dlCheck}
                                onChange={formik.handleChange}
                                id='dlCheck'/>}
                                label='Cuento con licencia de conducir oficial vigente.' />
                        <br/>
                        <sub>La licencia deberá ser presentada en recepción</sub>
                    </FormControl>
                </Grid2>
            </Grid2>
            <button style={{visibility: "hidden"}} id='submit' type='submit'>Submit</button>
            </form>
        </Container>
    )
}